import { RAISE_REASONS } from "../../lib/raiseReasons";
import { CAPITAL_PURPOSE_LABEL } from "../../lib/quizFunderPreview";

// Multi-select raise-purpose picker. Selection order is preserved —
// the first pick is the founder's PRIMARY reason (badge shown).
// Use-of-funds is displayed from the Get Started quiz selection (read-only
// chips) — the old free-text box was removed (Jun 2026).
export const RaisePurposePicker = ({ reasons, setReasons, other, setOther, quizPurposes }) => {
  const toggle = (code) => {
    setReasons(reasons.includes(code)
      ? reasons.filter((c) => c !== code)
      : [...reasons, code]);
  };
  return (
    <div data-testid="raise-purpose-picker">
      <p className="text-sm font-semibold text-neutral-900">Why are you looking to raise capital?</p>
      <p className="mt-0.5 text-xs text-neutral-500">Select all that apply — pick your main reason first.</p>
      <div className="mt-3 space-y-2">
        {RAISE_REASONS.map((r) => {
          const idx = reasons.indexOf(r.code);
          const on = idx >= 0;
          return (
            <button
              key={r.code}
              type="button"
              data-testid={`raise-reason-${r.code}`}
              onClick={() => toggle(r.code)}
              className={"flex w-full items-center gap-2 rounded-lg border px-3 py-2.5 text-left text-sm transition-colors " +
                (on
                  ? "border-[#0A8B85] bg-[#0A8B85]/5 text-neutral-900"
                  : "border-neutral-200 bg-white text-neutral-700 hover:border-[#0A8B85]/50")}
            >
              <span className={"flex h-4 w-4 flex-shrink-0 items-center justify-center rounded border text-[10px] font-bold " +
                (on ? "border-[#0A8B85] bg-[#0A8B85] text-white" : "border-neutral-300 bg-white")}>
                {on ? "✓" : ""}
              </span>
              <span className="flex-1">{r.label}</span>
              {idx === 0 && (
                <span className="rounded-full bg-[#0A8B85] px-2 py-0.5 text-[10px] font-bold text-white" data-testid="raise-reason-primary-badge">
                  Primary
                </span>
              )}
            </button>
          );
        })}
      </div>
      {reasons.includes("other") && (
        <input
          data-testid="raise-reason-other-input"
          placeholder="Please specify your reason"
          value={other}
          onChange={(e) => setOther(e.target.value)}
          className="mt-2 w-full rounded-lg border border-neutral-200 bg-white px-3 py-2.5 text-sm outline-none focus:border-[#0A8B85]"
        />
      )}
      {(quizPurposes || []).length > 0 && (
        <div className="mt-4" data-testid="quiz-use-of-funds">
          <p className="text-sm font-semibold text-neutral-900">Use of funds</p>
          <p className="mt-0.5 text-xs text-neutral-500">From your Get Started quiz answers.</p>
          <div className="mt-2 flex flex-wrap gap-2">
            {quizPurposes.map((p, i) => (
              <span key={p} data-testid={`use-of-funds-chip-${p}`}
                className="inline-flex items-center gap-1 rounded-full bg-[#0A8B85]/10 px-3 py-1 text-xs font-semibold text-[#0A8B85]">
                {CAPITAL_PURPOSE_LABEL[p] || p}
                {i === 0 && <span className="rounded-full bg-[#0A8B85] px-1.5 py-0.5 text-[9px] font-bold text-white">primary</span>}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
